import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetCurrentUserQuery = (enabled: boolean, refetch = true) => {
  const { users } = useAvApi();

  return useQuery({
    enabled,
    queryKey: ['current-user'],
    queryFn: async () => {
      const { data } = await users.getV2UsersInfo();

      return data;
    },
    retry: false,
    refetchOnWindowFocus: true,
    refetchInterval: refetch ? 60000 : undefined,
    staleTime: 100000,
  });
};
